var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatisnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0817 20.3591H4.93417C4.36808 20.3591 3.90918 20.818 3.90918 21.3841V41.9088C3.90918 42.4749 4.36808 42.9338 4.93417 42.9338H39.0817C39.6478 42.9338 40.1067 42.4749 40.1067 41.9088V21.3841C40.1067 20.818 39.6478 20.3591 39.0817 20.3591Z",
    stroke: "#FB5381",
    strokeWidth: 2.3589,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5232 11.4941H2.49079C1.92471 11.4941 1.46581 11.953 1.46581 12.5191V19.3307C1.46581 19.8968 1.92471 20.3557 2.49079 20.3557H41.5232C42.0893 20.3557 42.5482 19.8968 42.5482 19.3307V12.5191C42.5482 11.953 42.0893 11.4941 41.5232 11.4941Z",
    stroke: "#FB5381",
    strokeWidth: 2.3589,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8765 11.0486H17.333C14.8241 11.0486 12.7939 9.0057 12.7939 6.49098C12.7939 3.9718 14.8285 1.93332 17.333 1.93332C19.8419 1.93332 21.8721 3.97625 21.8721 6.49098V11.0486H21.8765Z",
    stroke: "#FB5381",
    strokeWidth: 2.3589,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1358 11.0486H26.6749C29.1838 11.0486 31.214 9.0057 31.214 6.49098C31.214 3.9718 29.1794 1.93332 26.6749 1.93332C24.166 1.93332 22.1358 3.97625 22.1358 6.49098V11.0486V11.0486Z",
    stroke: "#FB5381",
    strokeWidth: 2.3589,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9295 11.8389V42.4651",
    stroke: "#FB5381",
    strokeWidth: 2.3589,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatisnew);
export default __webpack_public_path__ + "static/media/whatisnew.9e910e1eea80aee62adaf1b78eb6bae8.svg";
export { ForwardRef as ReactComponent };